import React from 'react';
import { pillars } from '../../data/portfolioData';

export default function About() {
  return (
    <section className="section" id="about">
      <div className="container">
        <div className="section-head reveal">
          <div>
            <div className="section-tag">About</div>
            <h2>What I bring to a team.</h2>
          </div>
        </div>

        <div className="about-grid reveal">
          <div>
            <p className="about-bio">
              I&apos;m a <strong>backend and fullstack engineer</strong> focused on building reliable
              systems — APIs, data pipelines and AI infrastructure — that power real products used by
              real people.
            </p>
            <p className="about-bio">
              I work best on technically complex, product-driven work: designing clean API contracts,
              modeling data for growth, wiring AI capabilities into production backends and shipping
              fast without cutting corners.
            </p>
            <p className="about-bio">
              Based in <strong>Buenos Aires, Argentina</strong>. Available for senior backend,
              fullstack or AI systems roles — remote-first, open to anywhere.
            </p>
          </div>

          <div>
            <div className="pillars">
              {pillars.map(p => (
                <div key={p.title} className="pillar">
                  <div className="pillar-title">{p.title}</div>
                  <p className="pillar-text">{p.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
